// extracted by mini-css-extract-plugin
export default {"uproad":"uproadbutton_uproad__JTQaX"};